import React, { useEffect } from 'react';
import { StyleSheet, Text, View } from 'react-native';

import { ACTION, SCREEN } from '../../constants/mixpanel';

import { useConsumerQuery } from 'apollo/queries/autogenerate/hooks';
import Button from 'shared/modules/common/components/atoms/Button';
import Mixpanel from 'shared/vendor/Mixpanel';

const PLEASE_CHECK_EMAIL_EVENT = `${SCREEN.PLEASE_CHECK_EMAIL} - ${ACTION.PAGE_VIEW}`;

const EditUserPhoneEmailOTPSent = (props: {
  onNextButtonPress: () => void;
}) => {
  const { data } = useConsumerQuery({ fetchPolicy: 'cache-only' });

  useEffect(() => {
    Mixpanel.timeEvent(PLEASE_CHECK_EMAIL_EVENT);
  }, []);

  return (
    <>
      <View style={style.root}>
        <Text style={style.textTitle}>
          ご登録のメールアドレスに認証コードを送信しました
        </Text>
        <View style={style.spacer} />
        <Text>
          {data?.consumer.email}
          に送信された4桁の認証コードを確認してください。
        </Text>
        <View style={style.spacer} />
      </View>
      <Button
        title="次へ"
        style={style.nextButton}
        onPress={() => props.onNextButtonPress()}
        id="edit-user-phone-next-button"
      />
    </>
  );
};

const style = StyleSheet.create({
  root: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  textTitle: {
    fontSize: 20,
    fontWeight: '600',
    alignSelf: 'center',
  },
  spacer: {
    marginBottom: 24,
  },
  nextButton: {
    alignSelf: 'center',
  },
});

export default EditUserPhoneEmailOTPSent;
